import { Link } from "react-router-dom";

const LegalNotice = () => {
  return (
    <div className="privacy-policy">
      <h2 className="centered-heading">Aviso Legal</h2>

      <h3 className="heading-three">
        Aviso Legal y Normativas de Uso - Lexik.app
      </h3>
      <p className="p-color">Última actualización: 1 Mayo 2025</p>
      <br />

      <ol>
        <li>
          <b>Aviso Legal</b>
          <p className="p-color">
            El acceso y uso del sitio web de <b>Lexik.app</b> son gratuitos y
            están sujetos a las disposiciones legales vigentes. Todos los
            contenidos disponibles, incluidos textos, gráficos, imágenes y
            logotipos, son propiedad exclusiva de <b>Lexik.app</b> o de terceros
            licenciantes, y están protegidos por leyes de propiedad intelectual
            e industrial. Queda prohibida cualquier reproducción o uso de dichos
            contenidos sin la autorización previa y por escrito del titular.
          </p>
        </li>
        <li>
          <b>Aviso de Recopilación de Datos para Comunicaciones</b>
          <p className="p-color">
            Al registrarte en nuestra pre-landing page, recopilamos datos
            personales como tu correo electrónico para enviarte comunicaciones
            relacionadas con el lanzamiento de <b>Lexik.app.</b> El tratamiento
            de tus datos se basa en tu consentimiento expreso, y estos serán
            utilizados únicamente para enviarte información sobre
            actualizaciones, promociones y contenido relevante sobre la
            aplicación. Puedes retirar tu consentimiento en cualquier momento y
            ejercer tus derechos de acceso, rectificación, cancelación u
            oposición poniéndote en contacto con nosotros a través de
            legal@lexik.app
          </p>
        </li>
        <li>
          <b>Propiedad Intelectual</b>
          <p className="p-color">
            Todos los elementos de este sitio web están protegidos por derechos
            de propiedad intelectual e industrial. Esto incluye el diseño, el
            código, los textos, gráficos y logotipos que son propiedad de{" "}
            <b>Lexik.app</b> o de sus respectivos licenciantes. El acceso a la
            página no otorga ningún derecho de explotación sobre dichos
            contenidos. Está estrictamente prohibido el uso no autorizado,
            reproducción o distribución del contenido sin consentimiento.
          </p>
        </li>
        <li>
          <b>Normativa sobre Acceso Internacional</b>
          <p className="p-color">
            El sitio web de <b>Lexik.app</b> es accesible desde distintas
            ubicaciones internacionales. Si accedes desde fuera de [país de
            origen], lo haces bajo tu propia responsabilidad y debes asegurarte
            de cumplir con las leyes locales. Además, los datos que proporciones
            pueden ser transferidos y almacenados en servidores fuera de tu
            país. <b>Lexik.app</b> se compromete a tomar las medidas necesarias
            para proteger tus datos, de acuerdo con las leyes de privacidad
            internacionales aplicables.
          </p>
        </li>
        <li>
          <b>Exención de Responsabilidad</b>
          <p className="p-color">
            <b>Lexik.app</b> no garantiza que los contenidos, servicios o
            recursos proporcionados en el sitio web sean precisos, completos o
            estén actualizados en todo momento. Asimismo, no somos responsables
            de los daños o perjuicios derivados del uso indebido o incorrecto de
            la información proporcionada en el sitio web. Además,{" "}
            <b>Lexik.app</b> no será responsable por posibles limitaciones de
            acceso en ciertas jurisdicciones o por problemas técnicos derivados
            del uso del sitio web desde fuera de [país de origen].
          </p>
        </li>
        <li>
          <b>Contacto</b>
          <p className="p-color">
            Si tienes dudas sobre este documento, los términos de uso, o deseas
            hacer alguna reclamación relacionada con derechos de propiedad
            intelectual, recopilación de datos o cualquier otra cuestión legal,
            puedes ponerte en contacto con nosotros a través de:
          </p>
        </li>
      </ol>
      <br />
      <div className="contact-info">
        <p className="p-color">Antonia Koch</p>
        <p className="p-color">c/o Grosch Postflex #1270</p>
        <p className="p-color">Emsdettener Str. 10</p>
        <p className="p-color">48268 Greven</p>
        <p className="p-color">
          <Link
            className="text-decoration-none p-color"
            to={"mailto: legal@lexik.app"}
          >
            {" "}
            legal@lexik.app{" "}
          </Link>
        </p>
      </div>
    </div>
  );
};

export default LegalNotice;
